import { useEffect, useState } from "react";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import HomeIcon from "@material-ui/icons/Home";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { IoIosPricetags } from "react-icons/io";
import { Link } from "react-router-dom";

function Sidebar() {
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("UserDetails"));
    const isPortalView = JSON.parse(localStorage.getItem("isPortalView"));
    const iframe = localStorage.getItem("iframe") === "true";
    if (isPortalView && !iframe) {
      setUserLoggedIn(false);
    } else if (user) {
      setUserLoggedIn(true);
    } else {
      setUserLoggedIn(false);
    }
    // if (user) {
    //   setUserLoggedIn(true);
    // } else {
    //   setUserLoggedIn(false);
    // }

    // Add window resize listener
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Responsive layout
  const isMobile = windowWidth <= 768;

  const sidebarStyle = {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  };

  const sidebarContainerStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "10px 0",
  };

  const sidebarOptionsStyle = {
    display: "flex",
    flexDirection: isMobile ? "row" : "column",
    flexWrap: isMobile ? "wrap" : "nowrap",
    width: "100%",
    gap: isMobile ? "10px" : "0",
  };

  const sidebarOptionStyle = {
    display: "flex",
    flexDirection: "column",
    padding: "8px 0",
    width: isMobile ? "auto" : "100%",
  };

  const linkTagStyle = {
    display: "flex",
    alignItems: "center",
    padding: "8px 10px",
    borderRadius: "4px",
    fontSize: "13px",
    fontWeight: "bold",
    color: "inherit",
    textDecoration: "none",
    transition: "background-color 0.2s",
  };

  const linkStyle = {
    textDecoration: "none",
    color: "inherit",
    marginLeft: "10px",
  };

  return (
    <div style={sidebarStyle}>
      <div style={sidebarContainerStyle}>
        <div style={sidebarOptionsStyle}>
          <div style={sidebarOptionStyle}>
            <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
              <div
                style={linkTagStyle}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f1f2f3")
                }
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "")}
              >
                <HomeIcon
                  style={{ fontSize: "23px", color: "var(--black-500)" }}
                />
                <span style={linkStyle}>Home</span>
              </div>
            </Link>
          </div>
          <div style={sidebarOptionStyle}>
            <Link
              to="/allquestion"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div
                style={linkTagStyle}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f1f2f3")
                }
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "")}
              >
                <HelpOutlineIcon
                  style={{ fontSize: "23px", color: "var(--black-500)" }}
                />
                <span style={linkStyle}>Questions</span>
              </div>
            </Link>
          </div>
          <div style={sidebarOptionStyle}>
            <Link
              to="/tags"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div
                style={linkTagStyle}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f1f2f3")
                }
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "")}
              >
                <IoIosPricetags
                  style={{
                    fontSize: "20px",
                    color: "var(--black-500)",
                  }}
                />
                <span style={linkStyle}>Tags</span>
              </div>
            </Link>
          </div>
          {!isMobile && <div style={{ height: "16px" }}></div>}
          {userLoggedIn && (
            <div style={sidebarOptionStyle}>
              <Link
                to="/usersave"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div
                  style={linkTagStyle}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#f1f2f3")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "")
                  }
                >
                  <BookmarkIcon
                    style={{ fontSize: "23px", color: "var(--black-500)" }}
                  />
                  <span style={linkStyle}>Save</span>
                </div>
              </Link>
            </div>
          )}
          {userLoggedIn && (
            <div style={sidebarOptionStyle}>
              <Link
                to="/userdetails"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div
                  style={linkTagStyle}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#f1f2f3")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "")
                  }
                >
                  <GroupAddIcon
                    style={{ fontSize: "23px", color: "var(--black-500)" }}
                  />
                  <span style={linkStyle}>Users</span>
                </div>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
